import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, NgModel } from '@angular/forms';

@Component({
  selector: 'form-feedback',
  templateUrl: './form-feedback.component.html',
  styleUrls: ['./form-feedback.component.scss']
})
export class FormFeedbackComponent implements OnInit {

  @Input() public formGroup !: FormGroup;
  @Input() public field !: string;
  @Input() public control !: AbstractControl | NgModel;

  constructor() { }

  ngOnInit(): void {
    if(this.control) { return; }
    this.control = this.formGroup.get(this.field) as AbstractControl
  }

}
